/**
 * Fake attribute pickers (Diamond Shape / Metal) — filter product gallery by media alt.
 * Alt format: "Round,Yellow Gold" (comma-separated tokens).
 */
(() => {
  const states = new Map();

  function getState(sectionId) {
    if (!states.has(sectionId)) {
      states.set(sectionId, { shape: '', metal: '' });
    }
    return states.get(sectionId);
  }

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function altMatches(alt, shape, metal) {
    if (!alt) return false;
    const parts = String(alt)
      .split(',')
      .map((part) => normalize(part))
      .filter(Boolean);

    if (!parts.length) return false;

    const shapeNorm = normalize(shape);
    const metalNorm = normalize(metal);

    if (shapeNorm && !parts.includes(shapeNorm)) return false;
    if (metalNorm && !parts.includes(metalNorm)) return false;

    // At least one filter must be active
    return Boolean(shapeNorm || metalNorm);
  }

  function getGallery(sectionId) {
    return (
      document.querySelector(`#MediaGallery-${sectionId} gallery-carousel`) ||
      document.querySelector(`#MainProduct-${sectionId} gallery-carousel`) ||
      document.querySelector('gallery-carousel')
    );
  }

  function filterDesktopGrid(gallery, shape, metal) {
    const galleryContainer = gallery.querySelector('.splide__gallery');
    if (!galleryContainer) return;

    const slides = galleryContainer.querySelectorAll('.splide__slide');
    let visibleCount = 0;

    slides.forEach((slide) => {
      const shouldShow = altMatches(slide.dataset.mediaAlt, shape, metal);
      if (shouldShow) {
        slide.style.display = '';
        slide.classList.remove('hidden-by-filter');
        visibleCount += 1;
      } else {
        slide.style.display = 'none';
        slide.classList.add('hidden-by-filter');
      }
    });

    const currentSlideElement = gallery.querySelector('.current-slide');
    const totalSlidesElement = gallery.querySelector('.total-slides');
    if (currentSlideElement && totalSlidesElement) {
      currentSlideElement.textContent = visibleCount > 0 ? '1' : '0';
      totalSlidesElement.textContent = String(visibleCount);
    }
  }

  function filterCarousel(gallery, shape, metal) {
    if (!gallery.main || !gallery.thumbnails || !gallery.originalSlides) return;

    const mainList = gallery.main.Components?.Elements?.list;
    const thumbList = gallery.thumbnails.Components?.Elements?.list;
    if (!mainList || !thumbList) return;

    if (typeof gallery.saveMediaStates === 'function') {
      gallery.saveMediaStates();
    }

    mainList.innerHTML = '';
    thumbList.innerHTML = '';

    let slidesToShow = gallery.originalSlides.filter((slide) =>
      altMatches(slide.dataset.mediaAlt, shape, metal)
    );
    let thumbsToShow = gallery.originalThumbnails.filter((slide) =>
      altMatches(slide.dataset.mediaAlt, shape, metal)
    );

    // Fallback: if nothing matches, keep current filtered set empty-safe → show all tagged, else all
    if (!slidesToShow.length) {
      slidesToShow = gallery.originalSlides;
      thumbsToShow = gallery.originalThumbnails;
    }

    if (typeof gallery.updateArrowVisibility === 'function') {
      gallery.updateArrowVisibility(thumbsToShow.length);
    }

    const mainFragment = document.createDocumentFragment();
    const thumbFragment = document.createDocumentFragment();

    slidesToShow.forEach((slide) => {
      const cloned = slide.cloneNode(true);
      mainFragment.appendChild(cloned);
      if (typeof gallery.initializeMediaInSlide === 'function') {
        gallery.initializeMediaInSlide(cloned);
      }
    });

    thumbsToShow.forEach((slide) => {
      thumbFragment.appendChild(slide.cloneNode(true));
    });

    mainList.appendChild(mainFragment);
    thumbList.appendChild(thumbFragment);

    try {
      gallery.main.refresh();
      gallery.thumbnails.refresh();
      if (slidesToShow.length > 0) {
        gallery.main.go(0);
        gallery.thumbnails.go(0);
        if (typeof gallery.updateSlideCounter === 'function') {
          gallery.updateSlideCounter(0);
        }
        if (typeof gallery.restoreMediaStates === 'function') {
          gallery.restoreMediaStates();
        }
      }
    } catch (error) {
      console.error('product-fake-attrs filter error:', error);
    }

    gallery.querySelectorAll('responsive-image').forEach((responsiveImg) => {
      if (typeof responsiveImg.connectedCallback === 'function') {
        responsiveImg.connectedCallback();
      } else if (typeof responsiveImg.init === 'function') {
        responsiveImg.init();
      }
    });

    if (typeof gallery.updateThumbnailARIA === 'function') {
      gallery.updateThumbnailARIA();
    }
  }

  function applyFilter(sectionId) {
    const state = getState(sectionId);
    const gallery = getGallery(sectionId);
    if (!gallery) return;

    const isDesktopGrid =
      gallery.hasAttribute('desktop-grid') && window.innerWidth >= 768;

    if (isDesktopGrid) {
      filterDesktopGrid(gallery, state.shape, state.metal);
    } else if (gallery.main && gallery.originalSlides?.length) {
      filterCarousel(gallery, state.shape, state.metal);
    } else {
      // Gallery not ready yet — retry shortly
      setTimeout(() => applyFilter(sectionId), 120);
    }
  }

  function setActive(picker, value) {
    let activeBtn = null;
    picker.querySelectorAll('[data-fake-attr-value]').forEach((btn) => {
      const isActive = normalize(btn.dataset.fakeAttrValue) === normalize(value);
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      const swatch = btn.querySelector('.product-fake-attrs__swatch');
      if (swatch) swatch.classList.toggle('active-swatch', isActive);
      const text = btn.querySelector('.product-fake-attrs__text');
      if (text) text.classList.toggle('active-text', isActive);
      if (isActive) activeBtn = btn;
    });

    const faceValue = picker.querySelector('[data-pfa-face-value]');
    if (faceValue && value) faceValue.textContent = value;

    const faceIcon = picker.querySelector('[data-pfa-face-icon]');
    const srcImg = activeBtn?.querySelector('img');
    if (faceIcon && srcImg) {
      const faceImg = faceIcon.querySelector('img');
      if (faceImg) {
  // 优先使用当前选项配置的图标地址
const iconUrl =
  activeBtn.dataset.fakeAttrImage ||
  srcImg.currentSrc ||
  srcImg.src;

// 清除顶部图标原来的响应式图片候选
faceImg.removeAttribute('srcset');
faceImg.removeAttribute('sizes');

// 如有延迟加载地址，也同步为新图标
['data-src', 'data-srcset'].forEach((name) => {
  if (faceImg.hasAttribute(name)) {
    faceImg.setAttribute(name, iconUrl);
  }
});

// 如图标使用 picture，也同步里面的图片来源
faceIcon.querySelectorAll('source').forEach((source) => {
  source.setAttribute('srcset', iconUrl);

  if (source.hasAttribute('data-srcset')) {
    source.setAttribute('data-srcset', iconUrl);
  }
});

// 更新实际图片，保留原来的样式和尺寸
faceImg.loading = 'eager';
faceImg.src = iconUrl;
faceImg.alt = value || '';
      } else {
        faceIcon.innerHTML = '';
        faceIcon.appendChild(srcImg.cloneNode(true));
      }
    }
  }

  function syncCartProperty(picker, value) {
    const input = picker.querySelector('[data-fake-attr-property]');
    if (input) input.value = value || '';
  }

  function dispatchShapeChange(sectionId, value, imageUrl) {
    document.dispatchEvent(
      new CustomEvent('pfa:shape-change', {
        detail: { sectionId, shape: value, imageUrl: imageUrl || '' },
      })
    );
  }

  function getActiveShapeImage(picker, value) {
    const btn = [...picker.querySelectorAll('[data-fake-attr-value]')].find(
      (el) => normalize(el.dataset.fakeAttrValue) === normalize(value)
    );
    return btn?.dataset.fakeAttrImage || '';
  }

  function resolveInitial(picker) {
    const requested = picker.dataset.initialValue || '';
    const buttons = [...picker.querySelectorAll('[data-fake-attr-value]')];
    if (!buttons.length) return '';

    if (requested) {
      const match = buttons.find(
        (btn) => normalize(btn.dataset.fakeAttrValue) === normalize(requested)
      );
      if (match) return match.dataset.fakeAttrValue;
    }
    return buttons[0].dataset.fakeAttrValue;
  }

  function initPicker(picker) {
    if (picker.dataset.pfaReady === 'true') return;
    picker.dataset.pfaReady = 'true';

    const sectionId = picker.dataset.sectionId;
    const attrType = picker.dataset.attrType; // shape | metal
    const state = getState(sectionId);
    const initial = resolveInitial(picker);

    if (attrType === 'shape') state.shape = initial;
    if (attrType === 'metal') state.metal = initial;
    setActive(picker, initial);
    syncCartProperty(picker, initial);
    if (attrType === 'shape') {
      dispatchShapeChange(sectionId, initial, getActiveShapeImage(picker, initial));
    }

    picker.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-fake-attr-value]');
      if (!btn || !picker.contains(btn)) return;
      event.preventDefault();

      const value = btn.dataset.fakeAttrValue;
      if (attrType === 'shape') state.shape = value;
      if (attrType === 'metal') state.metal = value;
      setActive(picker, value);
      syncCartProperty(picker, value);
      applyFilter(sectionId);
      if (attrType === 'shape') {
        dispatchShapeChange(sectionId, value, btn.dataset.fakeAttrImage || '');
      }
    });
  }

  function boot() {
    const pickers = document.querySelectorAll('product-fake-attr-picker');
    if (!pickers.length) return;

    const sectionIds = new Set();
    pickers.forEach((picker) => {
      initPicker(picker);
      sectionIds.add(picker.dataset.sectionId);
    });

    // Wait for gallery-carousel Splide mount
    sectionIds.forEach((sectionId) => {
      const run = () => applyFilter(sectionId);
      run();
      setTimeout(run, 300);
      setTimeout(run, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
